import React, { useEffect, useState } from "react";
import UserNavbar from "./UserNavbar";
import MainSidebar from "./Mainsidebar";
import "../Style/LandingPage.css";
import "../Style/CrmDashboard.css";
import ss4 from "../Images/ss4.PNG";
import { Bar, Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js/auto";
import CrmDashboardsub from "./CrmDashboardsub";
import { useNavigate } from "react-router-dom";
import clipboardImage from "../Images/clipboard_10.png";
import { path_url } from "../Config/config";
import axios from "axios";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import { useCurrentUser } from "../context/UserContext";
import { isUUID } from "../Utils/auth";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function CustomerDashboard() {
  const { currentUser } = useCurrentUser();
  const [totalCustomer, setTotalCustomer] = useState(null);
  const [convertedCustomer, setConvertedCustomer] = useState(null);
  const [activeCustomer, setActiveCustomer] = useState(null);
  const [inactiveCustomer, setInactiveCustomer] = useState(null);
  const [customerCountByStatus, setCustomerCountByStatus] = useState({});

  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);

  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  const monthBgColors = [
    "rgba(255, 99, 132, 0.4)",
    "rgba(54, 162, 235, 0.4)",
    "rgba(255, 206, 86, 0.4)",
    "rgba(75, 192, 192, 0.4)",
    "rgba(153, 102, 255, 0.4)",
    "rgba(255, 159, 64, 0.4)",
    "rgba(199, 199, 199, 0.4)",
    "rgba(83, 102, 255, 0.4)",
    "rgba(153, 159, 64, 0.4)",
    "rgba(255, 99, 255, 0.4)",
    "rgba(54, 235, 86, 0.4)",
    "rgba(75, 75, 192, 0.4)",
  ];

  const defaultColor = "rgba(75, 192, 192, 0.4)";
  const [colorsOn, setColorsOn] = useState(true);
  const [chartKey, setChartKey] = useState(0);

  const getBackgroundColors = (on) => (on ? monthBgColors : defaultColor);

  const navigate = useNavigate();

  const handleCreateCustomer = () => {
    navigate("/new-customer");
  };

  const handleMoreInfo = (type) => {
    navigate(`/customers/${type}`, {
      state: { year: selectedYear, month: selectedMonth },
    });
  };

  const currentYear = new Date().getFullYear();
  const startYear = 2021;
  const years = Array.from(
    { length: Math.max(currentYear - startYear + 2, 4) },
    (_, i) => (startYear + i).toString()
  );
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(
    monthNames[new Date().getMonth()]
  );
  const [barChartData, setBarChartData] = useState({
    labels: monthNames,
    datasets: [
      {
        label: "Customer",
        data: Array(12).fill(0),
        backgroundColor: monthBgColors,
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  });

  const isDataAvailable = (data) =>
    data?.datasets?.[0]?.data?.some((value) => value > 0);

  useEffect(() => {
    const adminId = currentUser?.useradminid || currentUser?.id || localStorage.getItem("adminId");
    if (adminId && isUUID(adminId)) {
      fetchDashboardData(selectedYear, selectedMonth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedYear, selectedMonth, currentUser]);

  const fetchDashboardData = async (year, month) => {
    try {
      const token = localStorage.getItem("accessToken");
      const adminId =
        currentUser?.useradminid ||
        currentUser?.id ||
        localStorage.getItem("adminId");

      if (!adminId || !isUUID(adminId)) {
        console.warn(
          "CustomerDashboard: adminId is not a valid UUID yet, skipping fetch.",
          adminId
        );
        return;
      }

      const response = await axios.get(
        `${path_url}/customer/dashboard/${adminId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          params: { year, month },
        }
      );

      const data = response.data.body || response.data;

      setTotalCustomer(data.totalCustomer ?? null);
      setConvertedCustomer(data.convertedCustomer ?? null);
      setActiveCustomer(data.activeCustomer ?? null);
      setInactiveCustomer(data.inActiveCustomer ?? data.inactiveCustomer ?? null);

      if (data.customerCountByStatus) {
        setCustomerCountByStatus(data.customerCountByStatus);
      }

      const yearlyData = Array.from({ length: 12 }, () => 0);
      const yearObj =
        data.totalCustomerAddedByMonthInCurrentYear ||
        data.totalCustomerAddedByMonthinCurrentYear;
      if (yearObj) {
        Object.keys(yearObj).forEach((monthKey) => {
          const monthIndex = parseInt(monthKey, 10) - 1;
          if (monthIndex >= 0 && monthIndex < 12) {
            yearlyData[monthIndex] = yearObj[monthKey];
          }
        });
      }
      setBarChartData((prevData) => ({
        ...prevData,
        datasets: [
          {
            ...prevData.datasets[0],
            data: yearlyData,
          },
        ],
      }));
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const handleToggleChange = (event) => {
    const newColorsOn = event.target.checked;
    setColorsOn(newColorsOn);
    setBarChartData((prevData) => ({
      ...prevData,
      datasets: [
        {
          ...prevData.datasets[0],
          backgroundColor: getBackgroundColors(newColorsOn),
        },
      ],
    }));
    setChartKey((prevKey) => prevKey + 1);
  };

  const handleYearChange = (event) => {
    const yr = event.target.value;
    setSelectedYear(yr);
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          callback: function (value) {
            if (Number.isInteger(value)) {
              return value;
            }
          },
        },
      },
    },
  };

  const statusColors = {
    DISQUALIFIED: "rgba(255, 0, 0, 0.8)",
    QUALIFIED: "rgba(0, 255, 0, 0.8)",
    CONVERTTOCUSTOMER: "rgba(0, 0, 255, 0.8)",
    NEWOPPORTUNITY: "rgba(255, 255, 0, 0.8)",
    ATTEMPTEDCONTACT: "rgba(128, 0, 128, 0.8)",
    WORKING: "rgba(0, 128, 128, 0.8)",
    OPEN: "rgba(255, 165, 0, 0.8)",
    NEEDSFOLLOWUP: "rgba(255, 0, 0, 0.8)",
    NOTENGAGED: "rgba(128, 128, 128, 0.8)",
  };

  const chartData = {
    labels: Object.keys(customerCountByStatus),
    datasets: [
      {
        data: Object.values(customerCountByStatus),
        backgroundColor: Object.keys(customerCountByStatus).map(
          (status) => statusColors[status] || "rgba(255, 0, 0, 0.8)"
        ),
        borderColor: "rgb(245, 242, 242)",
        borderWidth: 4,
        borderRadius: 3,
      },
    ],
  };

  const rawName = currentUser?.name || localStorage.getItem("name") || "";
  const name =
    rawName && !rawName.includes("@")
      ? rawName
      : currentUser?.email
        ? currentUser.email.split("@")[0]
        : "User";

  const greetings = ["Good Morning 🌄", "Good Afternoon 🌇", "Good Evening 🌃"];
  const currentHour = new Date().getHours();
  let index =
    currentHour >= 12 && currentHour < 17 ? 1 : currentHour >= 17 ? 2 : 0;

  const hasChartData =
    isDataAvailable(barChartData) ||
    Object.values(customerCountByStatus).some((v) => v > 0) ||
    (totalCustomer !== null && totalCustomer > 0);

  return (
    <>
      <div className="con1 d-flex">
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />
          <link
            href="https://fonts.googleapis.com/css?family=Nunito:400,600,700&display=swap"
            rel="stylesheet"
          />
          <link
            href="https://fonts.googleapis.com/css?family=Muli:400,600,700&display=swap"
            rel="stylesheet"
          />

          <div className="greet">
            <div
              className="bg-white rounded mt-2 d-flex align-items-center subcon3"
              style={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)" }}
            >
              <div className="col-sm-4 mt-2 ml-2 mb-2 subcon6">
                <strong>
                  {greetings[index]}
                  {" " + name}
                </strong>
                <div className="mt-2">Welcome to the Customer Dashboard.</div>
              </div>
              <div className="col-8 d-flex justify-content-end pr-4 subcon4">
                <img
                  loading="lazy"
                  src={ss4}
                  alt="not load"
                  style={{ width: 200 }}
                />
              </div>
            </div>
          </div>

          <div className="row p-2 m-0">
            <div className="col-lg-3 col-6 mb-3 p-2">
              <CrmDashboardsub
                index={0}
                name="Total Customer"
                value={totalCustomer}
                icon="HiOutlineShoppingBag"
                class="bg-info"
                addOn=""
                onClick={() => handleMoreInfo("total")}
              />
            </div>
            <div className="col-lg-3 col-6 mb-3 p-2">
              <CrmDashboardsub
                index={1}
                name="Converted Customer"
                value={convertedCustomer}
                icon="BiBarChart"
                class="bg-success"
                addOn=""
                onClick={() => handleMoreInfo("converted")}
              />
            </div>
            <div className="col-lg-3 col-6 mb-3 p-2">
              <CrmDashboardsub
                index={2}
                name="Active Customer"
                value={activeCustomer}
                icon="BiSolidUserPlus"
                class="bg-warning"
                addOn=""
                onClick={() => handleMoreInfo("active")}
              />
            </div>
            <div className="col-lg-3 col-6 mb-3 p-2">
              <CrmDashboardsub
                index={3}
                name="Inactive Customer"
                value={inactiveCustomer}
                icon="IoMdPie"
                class="bg-danger"
                addOn=""
                onClick={() => handleMoreInfo("inactive")}
              />
            </div>
          </div>

          {hasChartData ? (
            <div className="col-12">
              <div className="row">
                {/* Yearly Customer Acquisitions Chart */}
                <div className="col-lg-6 mb-4">
                  <div
                    className="w-100 elevation-2 rounded p-0"
                    style={{ maxWidth: "100%", background: "#fff" }}
                  >
                    <div style={{ height: "350px" }}>
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ padding: "10px", height: "50px" }}
                      >
                        <div>
                          <FormGroup>
                            <FormControlLabel
                              label={`Colors ${colorsOn ? "On" : "Off"}`}
                              control={
                                <Switch
                                  checked={colorsOn}
                                  onChange={handleToggleChange}
                                />
                              }
                            />
                          </FormGroup>
                        </div>
                        <div>
                          <select
                            value={selectedYear}
                            onChange={handleYearChange}
                            className="form-select form-select-sm"
                            style={{ width: "100px" }}
                          >
                            {years.map((year) => (
                              <option key={year} value={year}>
                                {year}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div style={{ height: "85%", padding: "10px" }}>
                        <Bar
                          key={chartKey}
                          data={barChartData}
                          options={chartOptions}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Doughnut Chart */}
                <div className="col-lg-6 mb-4">
                  <div
                    className="w-100 elevation-2 rounded p-0"
                    style={{ maxWidth: "100%", background: "#fff" }}
                  >
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "350px", padding: "10px" }}
                    >
                      <Doughnut
                        data={chartData}
                        options={{
                          responsive: true,
                          maintainAspectRatio: false,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column align-items-center justify-content-center p-4 text-center">
              <img
                src={clipboardImage}
                alt="No Data"
                className="mb-3"
                style={{ width: "80px" }}
              />
              <div className="text-muted mb-2">
                <span>No data available to display.</span>
              </div>
              <button
                onClick={handleCreateCustomer}
                className="btn btn-primary"
              >
                Create Customer
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
